<template>
    <button
        v-tippy="t('editorToggleStrike')"
        :class="[
            buttonState(
                editor.can().toggleStrike() && editorSelection.text.length > 0,
                editor.isActive('strike'),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleStrike() || editorSelection.text.length === 0"
        @click="editor.chain().focus().toggleStrike().run()"
    >
        <MdiFormatStrikethrough class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import { MdiFormatStrikethrough } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'StrikeTextButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
        editorSelection: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
    const editorSelection = props.editorSelection;
</script>
